var _style, _path, _path2, _path3, _path4, _rect, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 64.4",
    style: {
      enableBackground: "new 0 0 71.6 64.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6FBF55;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E8F3E2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,59.2H21.3c-6.8,0-12.3-5.5-12.3-12.3V17.5c0-6.8,5.5-12.3,12.3-12.3h28.9c6.8,0,12.3,5.5,12.3,12.3v29.5 C62.5,53.7,57,59.2,50.3,59.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,25.3h7.8c0,0,5.9,0.5,6,6.7H14.2V25.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,25.3v7.8c0,0,0.5,5.9,6.7,6V25.3H29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.2,39.4h7.8c0,0,5.9-0.5,6-6.7H14.2V39.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.4,
    y: 25.3,
    className: "st2",
    width: 6.5,
    height: 13.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.7,32.7c0.2,3.7,3.3,6.7,7,6.7c3.8,0,6.8-3,7-6.7L43.7,32.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.8,32c-0.2-3.7-3.3-6.7-7-6.7c-3.8,0-6.9,3-7,6.7L57.8,32z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuo);
export default __webpack_public_path__ + "static/media/duo.2fef28ede7bceecf2e255521ebfd90b6.svg";
export { ForwardRef as ReactComponent };